/**
 * Resume Builder
 */
$(document).on("ready", function () {
    if ($("#resume-builder").length) {
        $("#resume-builder .save").on("click", function (e) {
            e.preventDefault();
            var nm = $(this).attr("data-savename") === undefined || $(this).attr("data-savename") == "" ? "My Resume" : $(this).attr("data-savename");
            var savetype = ($(this).attr('data-savetype') === undefined || $(this).attr('data-savetype') == '') ? '' : $(this).attr('data-savetype');
            var collegeSelected, jobSelected = '';
            if (savetype == 'College') {
                collegeSelected = 'selected';
            } else if (savetype == 'Job' || savetype == 'Career') {
                jobSelected = 'selected';
            }
            //console.log(nm);
           // addOverlay('resume-builder-save', '<div id="saveRb" class=""><div><label for="saveNameField">Save This Resume</label><input type="text" name="saveNameField" id="saveNameField" value="' + nm + '" placeholder="My Resume"></div><div><label for="saveTypeField">Type</label><select name="saveTypeField" id="saveTypeField"><option value=""></option><option value="College" ' + collegeSelected + '>College</option><option value="Career" ' + jobSelected + '>Career</option></select></div><div><label>&nbsp;</label> <a href="#" class="btn primary save">Save</a></div></div>');
            addOverlay('resume-builder-save','<div id="saveRb" class=""><div><label for="saveNameField">Save This Resume</label><input type="text" name="saveNameField" id="saveNameField" value="'+nm+'" placeholder="My Resume" style="margin-left: -.25rem"></div><div><label for="saveTypeField">Type</label><select name="saveTypeField" id="saveTypeField" style = "display:inline-block;padding: 5px 20px;margin-top:10px;height:29px;"><option value=""></option><option value="College" '+collegeSelected+'>College</option><option value="Career" '+jobSelected+'>Career</option></select></div><div><label>&nbsp;</label> <a href="#" class="btn primary save">Save</a></div></div>');
        
            $("#overlay .save").on("click", function (e) {
                e.preventDefault();
                $("#saveName").val($("#saveNameField").val());
                $('#saveType').val($('#saveTypeField').val());
                var nm2 = $("#saveNameField").val();
                var tp2 = $('#saveTypeField').val();
                if (nm2 == "") {
                    $("#savRbErrs").remove();
                    $('<div id="saveRbErrs" class="errors"><p class="error">Please enter a name for your resume.</p></div>').insertAfter("#saveRb label");
                } else {
                    if (tinyMCE) {
                        tinyMCE.triggerSave();
                    }
                    $.ajax({
                        type: "POST",
                        url: "/wp-admin/admin-ajax.php",
                        data: 'action=fw_resume_builder_save&' + $("#resume-builder form").serialize(),
                        success: function (data) {
                            $("#overlay").remove();
                            $("#saveName").val("");
                            setTimeout(() => {
                                window.location = fullBase + '/create-your-profile/resume-builder/?resume=' + nm2 + '&act=view';
                            }, 500);
                        },
                        error: function (data) {
                            console.log(data);
                        },
                    });
                }
            });
        });

        $('.view-saved .load').on('click', function (e) {
            var pl = $(this).attr("data-url");
            e.preventDefault();
            addWaiting();
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: 'fw_resume_builder_save',
                    load: pl,
                },
                success: function (data) {
                    removeWaiting();
                    addOverlay("resume-builder-load", data);
                },
                error: function (data) {
                    console.log(data);
                },
            });
        });
        $(document).on("click", ".resume-builder-load .remove", function (e) {
            var pl = $(this).attr("data-resume");
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: 'fw_resume_builder_save',
                    remove: true,
                    saveName: pl,
                },
                success: function (data) {
                    window.location = fullBase + "/create-your-profile/resume-builder/";
                },
                error: function (data) {
                    console.log(data);
                },
            });
        });
        $("#resume-builder .style").on("change", function () {
            var which = $(this).val();
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: 'action=fw_resume_builder_print&' + $("#resume-builder form").serialize(),
                success: function (data) {
                    $("#printResume").html(data);
                    $('.btn.primary.sendEmail').each(function () {
                        var hr = $(this).data('href');
                        if (which == 'modern' && $(this).hasClass('pdf')) $(this).attr('href', hr + '%26style=modern');
                        else if (which == 'classic' && $(this).hasClass('pdf')) $(this).attr('href', hr + '%26style=classic');
                        else if (which == 'modern' && $(this).hasClass('docx')) $(this).attr('href', hr + '&style=modern');
                        else $(this).attr('href', hr);
                    });
                },
                error: function (data) {
                    console.log(data);
                },
            });
        });

        $(function () {
            return;
            $(".sortable").sortable({
                revert: true,
                update: function () {
                    setTimeout(function () {
                        var newOrder = {'left': [], 'right': []};
                        $('#left .resume-block:not(.ui-sortable-placeholder)').each(function () {
                            console.log($(this));
                            newOrder.left.push($(this).attr('id').replace('-block', ''));
                        });
                        $('#right .resume-block:not(.ui-sortable-placeholder)').each(function () {
                            console.log($(this));
                            newOrder.right.push($(this).attr('id').replace('-block', ''));
                        });
                        $('#saveOrder').val(JSON.stringify(newOrder));

                    }, 500);
                }
            });
            $(".draggable").draggable({
                connectToSortable: ".sortable",
                containment: '#pieces',
            });
        });

    }
});